// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3_-F-","content":"styles_content__2h_86","selectAll":"styles_selectAll__2Zf-e"};